export const ARTBOARD_TYPE = "ARTBOARD";
export const ART_TYPE = "ART";

export const ART_STATUS_ACTIVE = "ACTIVE";
export const ART_STATUS_DRAFT = "DRAFT";

export const TYPE_GRID = "GRID";
